<template>
    <div class="sign_in">
        <login-in :loginType="loginType"
            :isLoginFlag="isLoginFlag"
            :activityTypeFlag="activityTypeFlag"
            :activityUrl="activityUrl"></login-in>
        <!-- 当前积分总数 -->
        <!-- 当前积分总数 -->
        <div :class="['float-points', activityObj.checkinCategory === CHECK_IN_CATEGORY.REGULAR_CHECK_IN ?'query-float-top': 'query-float-top-offline']">
            <div class="rule-and-query1"
                @click="goPointsMall">
                <span>积分</span>
                <span>{{ formCustom.totalPoints }}</span>
                <span>></span>
            </div>
        </div>
        <!-- 活动规则 -->
        <div class="float-item rule-float-top">
            <div v-if="formCustom.checkinGuideSwitch === '1'"
                class="rule-and-query"
                @click="isExplainShow = true">
                活动规则
            </div>
        </div>
        <!-- 奖励查询 -->
        <div class="float-item query-float-top">
            <div class="rule-and-query"
                @click="goMpRewardQuery">
                奖励查询
            </div>
        </div>
        <div v-if="activityObj.checkinCategory === CHECK_IN_CATEGORY.REGULAR_CHECK_IN"
            id="top-half"
            class="top-half">
            <!-- 星期日历 -->
            <div class="week-calendar"
                :style="{'height': isExpend ? '445px' : '218.5px'}">
                <div class="week-days">
                    <div v-for="(item, index) in weekDays"
                        :key="index">
                        {{ item}}
                    </div>
                </div>
                <div class="week-calendar-list"
                    :class="!isLoginFlag ? 'bg-gray-important' : ''">
                    <div v-for="(item, index) in weekList"
                        :key="index"
                        class="week-calendar-list-item">
                        <div class="week-calendar-day">
                            <div v-if="item.points"
                                :class="item.css.textClass">
                                {{ item.points }}
                            </div>
                            <img v-else
                                :src="item.css.img" />
                        </div>
                        <span v-if="item.today"
                            class="date today"
                            :class="getButtonStatus() ? 'text-gray-important' : ''">今天</span>
                        <span v-else
                            class="date not-today">{{ item.date }}</span>
                    </div>
                </div>
                <div v-show="!isExpend"
                    class="expend-more"
                    @click="isExpend = true">
                    <span>展开更多</span>
                    <van-icon name="arrow-down"
                        color="rgba(157,157,157,1)"
                        size="20"> </van-icon>
                </div>
                <div v-show="isExpend"
                    class="expend-more"
                    @click="isExpend = false">
                    <span>收起</span>
                    <van-icon name="arrow-up"
                        color="rgba(157,157,157,1)"
                        size="20"> </van-icon>
                </div>
                <!-- 签到按钮 -->
                <div id="sign-in-button"
                    :style="{'background': hadSingIn ? '#B7CDFB' : '#256FFF'}"
                    :class="getButtonStatus() ? 'disabled sign-in-button' : 'sign-in-button'"
                    :disabled="getButtonStatus()"
                    v-on:click.stop="signIn()">{{ getButtonText() }}</div>
            </div>
        </div>
        <div v-else
            id="top-half"
            class="top-half-offline">
        </div>
        <giftList ref="giftList"
            :isLoginFlag="isLoginFlag"
            :giftList="giftList"
            :noGift="noGift"
            @goUse="goUse"
            :checkinCategory="activityObj.checkinCategory"
            :isExpend="isExpend"></giftList>
        <!-- 签到成功弹窗-只有签到成功提示 -->
        <div v-show="isSuccessShow1"
            class="success_dialog_none">
            <div class="success"
                :class="showToJoin ? 'success_height' : ''">
                <img src="static/runtime/images/magic/signIn/check-mark-blue-big.png" />
                <div class="success_content">
                    <div class="success_title">恭喜您，签到成功</div>
                    <!-- 线下门店签到奖励无，跳转链接自定义，显示去参与按钮 -->
                    <div v-if="showToJoin"
                        class="to-join-btn"
                        @click="toJoin">去参与</div>
                </div>
                <div class="close_dialog">
                    <van-icon name="cross"
                        @click="closeSignSuccessModal" />
                </div>
            </div>
        </div>
        <!-- 签到成功弹窗-只有每日签到礼品 -->
        <div v-show="isSuccessShow2"
            class="success_dialog_point">
            <div class="success">
                <img :src="getPicUrl(successGiftList && successGiftList[0] && successGiftList[0].goodsPictureUrl)" />
                <div class="success_content">
                    <div class="success_point_title">签到成功，恭喜您获得</div>
                    <div class="success_point">{{ successGiftList && successGiftList[0] && successGiftList[0].points}}积分</div>
                    <div class="success_tip">{{ signInTip }}</div>
                    <div class="to_use"
                        @click="toUse(successGiftList && successGiftList[0])">
                        <div class="btn">去使用</div>
                    </div>
                </div>
                <div class="close_dialog">
                    <van-icon name="cross"
                        @click="isSuccessShow2 = false" />
                </div>
            </div>
        </div>
        <!-- 签到成功弹窗-获得多重礼品  -->
        <div v-show="isSuccessShow"
            class="success-dialog">
            <div class="success">
                <div class="success_title">签到成功，恭喜您获得</div>
                <div class="success_content">
                    <div v-for="(item, index) in successGiftList"
                        :key="index"
                        class="success-gift-list">
                        <div class="reward-content">
                            <img :src="getPicUrl(item.goodsPictureUrl)">
                            <div class="gift-info">
                                <div class="gift-item">
                                    <div>
                                        <div class="gift-title">
                                            {{ item.rewardTypeContent }}
                                        </div>
                                        <div class="gift-name">
                                            {{ item.rewardType === '4' ? `${item.points}积分` : item.rewardName}}
                                        </div>
                                    </div>
                                    <div class="button-item btn"
                                        @click="toUse(item)">
                                        去使用
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="reward_query"
                    @click="goMpRewardQuery">
                    <div class="btn">奖励查询</div>
                </div>
            </div>
            <div class="closeDialog">
                <van-icon name="cross"
                    @click="isSuccessShow = false" />
            </div>
        </div>
        <!-- 签到说明弹窗 -->
        <van-popup v-model="isExplainShow"
            closeOnClickOverlay
            class="van-dialog">
            <div class="explain">
                <div class="explain_title">活动规则</div>
                <div class="explain_content"
                    v-html="formCustom.checkinGuideInfo"></div>
                <div class="explain_closeDialog"
                    @click="isExplainShow = false">
                    <img src="../../../../static/runtime/images/magic/close-icon.png" />
                </div>
            </div>
        </van-popup>
        <!-- 实物权益品到店自提 -->
        <receiveAwardModal ref="receiveAwardModal"
            :activityUrl="activityUrl"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :drawType="drawType"
            :miniFlag="miniprogramFlag"
            @openKindAwardModal="openKindAwardModal">
        </receiveAwardModal>
        <!-- 实物+线上邮寄 -->
        <realOnlineMailingModal ref="realOnlineMailingModal"
            :activityUrl="activityUrl"
            :awardObj="awardObj"
            :activityObj="activityObj"
            :userBase="userBase"
            :drawType="drawType"
            @handleRealOnlineMailing="getReceiveData(arguments)">
        </realOnlineMailingModal>
        <!-- 虚拟+线上兑换 -->
        <virtualOnlineAwardModal ref="virtualOnlineAwardModal"
            :awardObj="awardObj"
            :userInfoList="userInfoList"
            :userBase="userBase"
            :isReceived="isReceived"
            @handleVirtualOnline="getReceiveData(arguments)"
            @nextStep="toNextStep"></virtualOnlineAwardModal>
        <!-- 实物+线下兑换、虚拟+线下核销发卡密、虚拟+线下核销 -->
        <codeCancelAfterVerfication v-if="codeShow"
            :awardObj="awardObj"
            :codeUrl="awardObj.writeOffCodeUrl"
            :writeOffCode="awardObj.writeOffCode"
            :extendConfigFlag="awardObj.extendConfigFlag"
            :activationCode="awardObj.activationCode"
            :effectiveStartTime="awardObj.effectiveStartTime"
            :effectiveEndTime="awardObj.effectiveEndTime"
            @closeEnd="closeEnd"
            @queryStatus="queryStatus"
            @refreshTaskList="refreshTaskList"
            @nextStep="toNextStep"></codeCancelAfterVerfication>
        <offlineCheckQrCode ref="offlineQrCodeCheckRef"
            :activityCode="activityCode"
            :positionInfo="positionInfo"
            :loginType="loginType"
            @refresh="refreshTaskList"
            @checkInSuccess="checkInSuccessHandler"></offlineCheckQrCode>
        <!-- 活动未开始、已暂停、已结束弹窗 -->
        <activity-status-dialog ref="activityStatusDialogRef"
            :activityStatus="activityStatus"
            :activityStartDate="activityStartTime"
            :activityEndDate="activityEndTime"></activity-status-dialog>
        <IncorrectClient :isDisplay="!isCorrectClient"
            :loginType="originLoginType"></IncorrectClient>
    </div>
</template>
<script>
import loginIn from './dynamicAttr/modal/login-in.vue';
import wx from 'weixin-js-sdk';
import { Dialog, Toast, Icon, Button, Calendar, Popup } from 'vant';
import comUtils from '@/utils/comUtils.js';
import { config } from '../../../commons/config.js';
import receiveAwardModal from './dynamicAttr/modal/receiveAwardModal';
import virtualOnlineAwardModal from './dynamicAttr/modal/virtual-online';
import realOnlineMailingModal from '../../../components/modal/real-online-mailing-modal.vue';
import codeCancelAfterVerfication from '../../../components/modal/code-cancel-after-verification.vue';
import ActivityStatusDialog from '../../vibrantRubikCube/runtime/themaicComponent/activity-status-dialog.vue';
import { queryNeedNotifyAwardInfo } from '../../../commons/commonJudgeIsNeedNotify.js';
import { CHECK_IN_CATEGORY } from '../../../commons/commonVariables';
import {
  JumpType,
  SignInStatus,
  SignInGiftStatus,
  GoodsType,
  AppointmentFlag,
  CollectionType,
  SignInCheckInType,
  LoginType,
  EnableMessageNotifications,
  SignInTaskType,
  PMLinkType,
} from '../../../commons/commonVariables.js';
import offlineCheckQrCode from './sign-in-components/offline-check-qr-code.vue';
import giftList from './sign-in-components/gift-list.vue';
import { CoordinateType } from './lucky-draw/common/global-variable';
import { AMapGetLocation } from './TMap.js';
import { loadAlipayWebViewScript } from '../../../utils/comUtils.js';
import {
  jumpToNext,
  goHiHonorIndex,
  noLoginHandler,
  getSignUrl,
  getValidity,
  checkClient,
  jumpToPointsMall,
  pointsMallLinkJudge,
  getPosition,
} from './common-methods/utils';
import { BigWheelConstants as BWC } from './lucky-draw/common/global-variable';
import IncorrectClient from './dynamicAttr/incorrect-client.vue';

export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Toast.name]: Toast,
    [Icon.name]: Icon,
    [Button.name]: Button,
    [Calendar.name]: Calendar,
    [Popup.name]: Popup,
    loginIn,
    receiveAwardModal,
    virtualOnlineAwardModal,
    realOnlineMailingModal,
    codeCancelAfterVerfication,
    offlineCheckQrCode,
    giftList,
    IncorrectClient,
    ActivityStatusDialog,
  },
  props: {
    activityObj: Object,
  },
  data() {
    return {
      GoodsType: GoodsType,
      activityTypeFlag: '',
      isLoginFlag: false, // 默认没有登录
      taskId: '', //会员 任务中心 任务id
      activityCode: '',
      unionId: '',
      formCustom: {
        status: '', //活动状态
        userCountCheckDays: '', //用户签到天数
        userCheckDays: '', //用户连续签到天数
        checkinGuideSwitch: '', //是否开启签到攻略
        checkinGuideInfo: '', //签到攻略
        extraAward: [], //优惠券
        tips: '',
        checkinOnOff: '', //签到类型
        unsignedButtonUrl: '', //未签到
        signedButtonUrl: '', //已签到
        signBackgroundUrl: '', //签到背景
        pointRewardUrl: '', //积分奖品
        couponRewardUrl: '', //优惠券奖品
        rightRewardUrl: '', //权益品奖品
        totalPoints: 0, // 用户当前积分总数
        activityStartTime: '', // 活动开始时间
        activityEndTime: '', // 活动结束时间
      },
      clickFlag: false,
      awardObj: {
        extendReward: {},
      },
      drawCode: '', //多门店抽奖code
      channelCode: '', //门店编码
      isExplainShow: false,
      isSuccessShow1: false, // 签到成功弹窗显示控制-只有签到成功提
      isSuccessShow2: false, // 签到成功弹窗显示控制-获得每日签到
      isSuccessShow: false, // 签到成功弹窗显示控制-获得多重礼品
      signInTip: '', // 每日签到提示
      //日历
      dateTime: [],
      signData: '', // 签到日历H5端显示开关0.不显示 1.显示
      isCheckinCalendar: false,
      loginType: '', // 活动登录类型
      miniprogramFlag: false, //判断是否在小程序打开
      userBase: '', // 用户登录数据
      memberInfo: '', // 会员信息
      signInFlag: false, // false -> 可正常签到，true -> 条件不满足，比如当前用户不是会员
      windowHiddenFlag: false, // 页面是否隐藏至后台
      windowShowFlag: false, // 是否打开或回到当前页面
      onLinePunchModal: false, //线上连续打卡说明弹框
      offlinePunchModal: false, //线下连续打卡说明弹框
      quidePath: '', //跳小程序路径
      checkinLocation: '', //记录签到类型
      onToOffFlag: true,
      envVersion: config.env === 'pro' ? 'release' : 'trial',
      giftList: [],
      dateInfoList: [], // 本周签到信息，接口返回
      selectDay: '',
      today: '',
      hadSingIn: '', //是否已签到  0为未签到  1已签
      successGiftList: [], // 签到成功弹窗礼品列表
      successSignInPoint: '',
      drawType: 'initDraw',
      checkinType: '',
      automaticCheckIn: false,
      dialogData: {
        showDialog: false,
        url: '',
      },
      signInFailed: false,
      checkRecordId: '',
      isReceived: false,
      activityEnd: false, // 活动已结束
      activityPaused: false, // 活动已暂停
      activityNotStarted: false, // 活动未开始
      noGift: '坚持打卡，获得奖励',
      userInfoList: [],
      codeShow: false,
      positionInfo: {}, // 当前位置信息
      adminRegions: {}, //行政区域ID对象
      originLoginType: LoginType.None,
      isCorrectClient: true,
      isExpend: false,
      weekDays: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      showToJoin: false, //线下门店签到奖励无，跳转链接无，不显示去参与按钮
      CHECK_IN_CATEGORY: CHECK_IN_CATEGORY,
      activityStatus: '', // 当前活动状态
      activityStartTime: '',
      activityEndTime: '',
    };
  },
  computed: {
    weekList() {
      const date = new Date();
      //一天的毫秒数
      const ondDayTime = 86400000;
      //-1是因为要把当天的毫秒数去掉
      // getDay():Sunday - Saturday : 0 - 6
      let day = date.getDay() - 1;
      let firstDay = '';
      //如果<0，就是周末，所以取6
      day < 0 ? (day = 6) : '';
      // 算出当天所在的周对应的周一是哪一天
      firstDay = new Date(date.getTime() - day * ondDayTime);
      let week = [];
      // 是否签到
      for (let i = 0; i <= this.dateInfoList.length - 1; i++) {
        // 接口返回的是总共35天数据，第1条数据为周一，但可能不是当前周的周一会早于当前的周一数据，返回的数据格式为YYYY-MM-DD
        const beginMonday = this.dateInfoList && this.dateInfoList[0] && this.dateInfoList[0].checkinDate;
        const everyDate = new Date(new Date(beginMonday).getTime() + i * ondDayTime);
        const item = {
          //可换成星期
          dateToInterface: this.dateFormat2(everyDate), // YYYY-MM-DD
          day: i,
          date: this.dateFormat(everyDate), // MM.DD
          today: this.dateFormat(everyDate) === this.dateFormat(new Date()), // 是否今天
          css: {
            img: '',
            textClass: '',
          },
          points: 0, // 返回的每一天数据对应的签到积分，若为0，则展示一个签字(签到过的、今天的、配置有礼物图标展示图标)
        };
        if (this.dateInfoList.length > 0) {
          // 签到过的
          if (this.dateInfoList[i].isSignIn) {
            item.css.img = 'static/runtime/images/magic/signIn/check-mark-blue-small.png';
          } else {
            // 因接口返回指定日期格式为 YYYY-MM-DD，需先把当天对应的时间转化为YYYY-MM-DD，再转成毫秒做对比
            const currDay = new Date(this.dateFormat2(new Date())).getTime();
            // 签到活动结束时间
            const endDay = this.formCustom.activityEndTime && this.formCustom.activityEndTime.split(' ')[0];
            if (this.dateInfoList[i].points === 0) {
              item.points = '签';
              item.css.textClass = 'sign-font';
              // 如果指定日期大于当天，展示的签字不置灰
              if (currDay <= new Date(item.dateToInterface).getTime()) {
                item.css.textClass = 'points-font';
              }
              // 如果指定日期大于活动结束时间（既不在活动范围内），展示的签字置灰
              if (endDay && new Date(endDay).getTime() < new Date(item.dateToInterface).getTime()) {
                item.css.textClass = 'sign-font';
              }
            } else {
              item.points = `+${this.dateInfoList[i].points}`;
              item.css.textClass = 'points-font';
              // 如果指定日期小于当天但未签到，展示的积分置灰
              if (new Date(item.dateToInterface).getTime() < currDay) {
                item.css.textClass = 'sign-font';
              }
            }
          }
          // 有配置礼物-针对的是指定日期签到的才有
          if (this.dateInfoList[i].haveGift) {
            // 配置有礼物图标，不展示积分直接展示图标
            item.points = 0;
            item.css.img = 'static/runtime/images/magic/signIn/sign-in-gift.png';
          }
          // 今天
          if (item.today) {
            if (this.dateInfoList[i].isSignIn) {
              this.hadSingIn = true;
            }
            // 没有自动签到，且当天没有签到过，且后台配置了自动签到，进入就去调签到接口
            if (!this.automaticCheckIn && !this.hadSingIn && this.checkinType === SignInCheckInType.automaticCheckIn) {
              // 支付宝场景，是新会员，不做自动签到
              if (this.loginType === LoginType.Alipay && sessionStorage.getItem('isMember') === 'false') {
                // 不做自动签到
              } else {
                this.signIn();
              }
            }
          }
        } else {
          // 扫码一瞬间接口数据多(固定35条数据)可能没及时返回，保持原有逻辑不变，先用图片替换
          item.css.img = 'static/runtime/images/magic/signIn/check-mark-gray.png';
          if (item.today) {
            item.css.img = 'static/runtime/images/magic/signIn/check-mark-white.png';
          }
        }
        const loginFlag = sessionStorage.getItem('isLoginFlag') === 'true' ? true : false;
        if (!loginFlag || this.activityEnd || this.activityPaused || this.activityNotStarted) {
          // 未登陆时，展示数据样式和登陆时一样。只是在此基础上置灰，css: bg-gray-important
          if (this.dateInfoList.length > 0) {
            // 签到过的
            if (this.dateInfoList[i].isSignIn) {
              item.css.img = 'static/runtime/images/magic/signIn/check-mark-blue-small.png';
            } else {
              if (this.dateInfoList[i].points === 0) {
                item.points = '签';
                item.css.textClass = 'sign-font';
              } else {
                item.points = `+${this.dateInfoList[i].points}`;
                item.css.textClass = 'points-font';
              }
            }
            // 有配置礼物-针对的是指定日期签到的才有
            if (this.dateInfoList[i].haveGift) {
              // 配置有礼物图标，不展示积分直接展示图标
              item.points = 0;
              item.css.img = 'static/runtime/images/magic/signIn/sign-in-gift.png';
            }
            // 今天
            if (item.today) {
              if (this.dateInfoList[i].isSignIn) {
                this.hadSingIn = true;
              }
            }
          }
        }
        week.push(item);
      }
      if (!this.isExpend) {
        // 当天所在的周对应的周一转化为YYYY-MM-DD
        const currWeekMonday = this.dateFormat2(firstDay);
        // 当天所在的周对应的周一在返回数据所在的位置
        const currWeekIndex = week.findIndex((item) => item.dateToInterface === currWeekMonday);
        // 截取当天所在的周从周一到周日的数据
        week = week.slice(currWeekIndex, currWeekIndex + 7);
      }
      return week; //结果
    },
  },
  async created() {
    this.originLoginType = sessionStorage.getItem('originLoginType');
    const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
    this.isCorrectClient = checkClient(this.originLoginType);
    let userInfo = sessionStorage.getItem('userInfo');
    if (userInfo) {
      userInfo = JSON.parse(userInfo);
      this.userBase = userInfo;
      this.unionId = userInfo.unionid || '';
    }
    this.loginType = sessionStorage.getItem('loginType');
    console.log('sign-in-loginType', this.loginType);
    this.adminRegions = JSON.parse(sessionStorage.getItem('adminRegions')) || {};
    this.activityTypeFlag = sessionStorage.getItem('activityTypeFlag') || '1';
    this.taskId = this.$route.query && this.$route.query.taskId;
    const code = this.$route.query && this.$route.query.activityCode;
    this.isLoginFlag = sessionStorage.getItem('isLoginFlag') === 'true' ? true : false;
    this.activityCode = code;
    if (code && code.indexOf('_') > -1) {
      this.drawCode = code;
    }
    if (this.drawCode) {
      this.activityCode = this.drawCode.split('_')[0];
      this.channelCode = this.drawCode.split('_')[1];
    }
    // 组装当前地址
    this.activityUrl = location.origin + '/hd/hdmain?activityCode=' + code;
    if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
      this.activityUrl =
        this.activityUrl + '&ay=' + eventTrackingData.activityType + '&GUID=' + eventTrackingData.guideUserId + '&SC=' + eventTrackingData.storeCode;
    }
    // 判断是否在小程序内
    this.handleMiniprogramJudge();

    if (this.taskId) {
      this.handleIntoSignIn(); //埋码-会员中心任务
    }

    const myDate = new Date(new Date().getTime() + 8 * 60 * 60 * 1000);
    const time = myDate.toJSON().split('T').join(' ').substr(0, 19).split(' ')[0]; //将1970/08/08转化成1970-08-08
    this.today = time;
    this.selectDay = time;
    const positioningFlag = sessionStorage.getItem('positioningFlag') === 'true' ? true : false;
    // 针对普通签到，positioningFlag为true需要传经纬度、false不需要传
    if (positioningFlag) {
      this.positionInfo = await getPosition();
    }
    this.getSignInMsg(time);
  },

  mounted() {
    // 锁定微信 WebView 字体缩放，防止用户调大系统/微信字体后导致布局错乱
    const lockWxFontSize = () => {
      WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
    }
    if (typeof WeixinJSBridge !== 'undefined') {
      lockWxFontSize()
    } else {
      document.addEventListener('WeixinJSBridgeReady', lockWxFontSize, false)
      this.$once('hook:beforeDestroy', () => {
        document.removeEventListener('WeixinJSBridgeReady', lockWxFontSize, false)
      })
    }
  },
  methods: {
    // 跳转积分商城
    goPointsMall() {
      jumpToPointsMall(this.activityCode);
    },
    // 未登陆、已结束、已暂停、未开始样式
    getButtonStatus() {
      return !this.isLoginFlag || this.activityEnd || this.activityPaused || this.activityNotStarted;
    },
    queryStatus(awardObj) {
      this.giftList.forEach((item) => {
        if (item.id === awardObj.id) {
          item.usedFlag = '4';
        }
      });
    },
    getButtonText() {
      let text = '';
      if (this.activityEnd) {
        text = '活动已结束';
        return text;
      }
      if (this.activityPaused) {
        text = '活动已暂停';
        return text;
      }
      if (this.activityNotStarted) {
        text = '活动未开始';
        return text;
      }
      return this.hadSingIn ? '已签到' : '线上签到';
    },
    //日期格式化
    dateFormat(date) {
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return month + '.' + day;
    },
    dateFormat2(date) {
      const year = new Date().getFullYear();
      const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
      return `${year}-${month}-${day}`;
    },
    getReceiveData(msg) {
      let param = {};
      if (msg.length === 0) {
        setTimeout(() => {
          this.toNextStep();
        }, 1000);
        this.$refs.realOnlineMailingModal.modalCancel();
        return;
      }
      if (msg.length === 3) {
        param = {
          checkRecordId: this.checkRecordId,
          userInfo: {
            ...msg[2],
          },
        };
      } else if (msg.length === 4) {
        param = {
          checkRecordId: this.checkRecordId,
          userInfo: {
            userName: msg[2],
            userPhone: msg[3],
          },
        };
      } else {
        param = {
          checkRecordId: msg.checkinRecordId,
        };
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkin/receiveCheckinRecord`,
        params: param,
        success: (r) => {
          if (r.code === 200) {
            this.$refs.realOnlineMailingModal.modalCancel();
            Toast('领取成功');
            if (this.awardObj.rewardType === '1' && this.awardObj.collectionType === '1') {
              this.isReceived = true;
              this.awardObj.activationCode = r.result;
            } else if (this.awardObj.rewardType === GoodsType.entityAward && this.awardObj.collectionType === CollectionType.expressOrOnlineCheckOff) {
              setTimeout(() => {
                this.toNextStep();
              }, 1000);
            }
            this.getSignInMsg(this.selectDay);
          } else {
            Toast(r.message);
          }
        },
      });
    },
    closeDialog() {
      this.dialogData.showDialog = false;
    },
    submitDialog() {
      this.dialogData.showDialog = false;
      if (this.awardObj.appointmentFlag === '1') {
        wx.miniProgram.navigateTo({
          url: `/subpackages/activity/pages/shoppersService/createService/create-service?activationCodeId=${this.awardObj.activationCodeId}&collectionType=${this.awardObj.collectionType}`,
        });
      }
    },
    // 跳转小程序奖励查询页
    goMpRewardQuery() {
      if (!this.isLoginFlag && (this.loginType === 'wechat' || this.loginType === 'Alipay')) {
        this.$utils.tips.message('warning', '请先登录，再查看');
        return;
      }
      jumpToNext('', JumpType.rewardInquiry, this.loginType, this);
    },
    goUse(item) {
      console.log(item);
      // 奖项状态 0、未开始 1、已使用 2、 去使用  3、未达到条件/去完成 4、已领完 5、待领取 6、已过期
      const data = JSON.parse(JSON.stringify(item));
      // 未登录，待生效，已使用，已领完，已过期
      if (
        !this.isLoginFlag ||
        data.status === SignInGiftStatus.readyToTakeEffect ||
        data.status === SignInGiftStatus.used ||
        data.status === SignInGiftStatus.takeAll ||
        data.status === SignInGiftStatus.expired
      ) {
        return;
      }

      if (this.loginType === LoginType.Alipay && sessionStorage.getItem('isMember') === 'false') {
        goHiHonorIndex(this.loginType, this.activityUrl);
        return;
      }

      // 未达领取条件/去完成，且是线下门店签到任务
      if (data.status === SignInGiftStatus.notMeetConditions && data.rewardSettingType === SignInTaskType.offlineStoreCheckIn) {
        this.$refs.offlineQrCodeCheckRef.open(data);
      }
      // 去使用
      if (data.status === SignInGiftStatus.readyToUse) {
        // 积分
        if (data.rewardType === GoodsType.accumulatePoints) {
          this.awardObj = data;
          this.toNextStep();
        } else {
          // 不是积分
          this.toUse(data);
        }
      }
      // 待领取
      if (data.status === SignInGiftStatus.readyToTake) {
        this.getReceiveData(item);
      }
    },
    // 奖品弹窗处理
    async toUse(item) {
      this.userInfoList = item.userInfoList || [];
      this.checkRecordId = item.bigwheelRewardRecodeId || item.checkinRecordId;
      this.isSuccessShow2 = false;
      this.isSuccessShow = false;
      this.awardObj = item;
      this.awardObj.openSrc = '';
      this.awardObj.bigWheelActivityType = 1;
      this.activityObj.extendConfig = {
        awardPopupButtonColor: '',
      };
      let isNext = false;
      const params = {
        goodsId: this.awardObj.goodsId || '', //(权益品id)",
        rewardRecodeId: this.checkRecordId || '', //(中奖记录表id)
        activityCode: this.awardObj.activityCode || '', //活动编码
      };
      try {
        // 虚拟奖品-线上兑换
        if (this.awardObj.rewardType === GoodsType.virtualAward && this.awardObj.collectionType === CollectionType.expressOrOnlineCheckOff) {
          if (!item.activationCode) {
            // 用户未领取卡密
            isNext = await getValidity(params, item.rewardType);
          }
        } else {
          // 其他权益品
          isNext = await getValidity(params, item.rewardType);
        }
      } catch (err) {
        console.error(err);
      }
      // rewardType ,0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券
      // collectionType 领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟))
      //虚拟权益品
      if (item.rewardType === GoodsType.virtualAward) {
        setTimeout(() => {
          // 虚拟权益品 - 需要预约导购 - 线下核销 或 线下核销发串码
          if (
            item.appointmentFlag === AppointmentFlag.need &&
            (item.collectionType === CollectionType.inStore || item.collectionType === CollectionType.checkOffStrCode) &&
            isNext
          ) {
            this.toAppointmentGuide();
          } else {
            // 虚拟权益品 - 不需要预约导购 - 线上兑换
            if (item.collectionType === CollectionType.expressOrOnlineCheckOff && (isNext || item.activationCode)) {
              this.drawType = 'exchangegoods';
              if (item.activationCode) {
                this.isReceived = true;
              } else {
                this.isReceived = false;
              }
              this.$refs.virtualOnlineAwardModal.openModel();
            }
            // 虚拟权益品 - 不需要预约导购 - 线下核销、线下核销发串码
            if ((item.collectionType === CollectionType.checkOffStrCode || item.collectionType === CollectionType.inStore) && isNext) {
              item.drawOrderSource = null;
              this.codeShow = true;
            }
          }
        }, 100);
      }
      // 实物权益品
      else if (item.rewardType === GoodsType.entityAward) {
        // 实物权益品 - 到店自提 - 需要预约导购
        if (item.appointmentFlag === AppointmentFlag.need && item.collectionType === CollectionType.inStore && isNext) {
          this.toAppointmentGuide();
        } else {
          // 不需要预约导购
          // 实物权益品 - 邮寄 - 不需要预约导购
          if (item.collectionType === CollectionType.expressOrOnlineCheckOff && isNext) {
            // 实物权益品 - 邮寄 - 不需要预约导购，判断权益品是否在有效期内
            this.drawType = 'exchangegoods';
            // 实物 - 邮寄
            if (item.extendConfig) {
              const userData = JSON.parse(item.extendConfig);
              item.extendConfigFlag = true;
              item.userAddressDetail = userData.userAddress.anonymizedText;
              item.userName = userData.userName.anonymizedText;
              item.userPhone = userData.userPhone.anonymizedText;
              item.userAddress = `${userData.userProvinceName}/${userData.userCityName}/${userData.userZoneName}`;
            }
            this.$nextTick(() => {
              this.$refs.realOnlineMailingModal.openModel();
            });
          }
          // 实物权益品 - 到店自提 - 不需要预约导购
          if (item.collectionType === CollectionType.inStore && isNext) {
            item.goodsPictureUrl = item.picUrl;
            item.goodsName = item.rightsName;
            this.codeShow = true;
          }
        }
      }
      // 优惠券、代金券
      else if (item.rewardType && [GoodsType.coupon, GoodsType.voucher].includes(item.rewardType)) {
        this.toNextStep();
      }
      // 赠品券
      else if (item.rewardType === GoodsType.giftCoupon) {
        setTimeout(() => {
          if (
            item.appointmentFlag === AppointmentFlag.need &&
            (item.collectionType === CollectionType.inStore || item.collectionType === CollectionType.checkOffStrCode)
          ) {
            if (isNext) {
              this.toAppointmentGuide();
            }
          } else {
            item.collectionType = CollectionType.inStore;
            item.drawOrderSource = null;
            this.codeShow = true;
          }
        }, 100);
      }
      // 积分 或 未中奖
      else if ([GoodsType.accumulatePoints, GoodsType.noAward].includes(item.rewardType)) {
        this.toNextStep();
      }
    },
    toNextStep() {
      // 跳转积商城，需要携带活动编码
      if (pointsMallLinkJudge(this.awardObj.jumpUrl) !== PMLinkType.notMatch) {
        jumpToPointsMall(this.activityCode, this.awardObj.jumpUrl);
      } else {
        jumpToNext(this.awardObj.jumpUrl, this.awardObj.jumpType, this.loginType, this);
      }
    },
    //实物奖品录入完客户信息再打开实物奖品弹框
    openKindAwardModal() {
      this.$refs.kindAwardModal.openModel();
    },
    // 获取图片地址
    getPicUrl(data) {
      if (data) {
        return this.$utils.getImageUrl(JSON.parse(data).file);
      }
    },
    /**
     * 查询签到信息，包括签到情况，任务列表等
     * @param {*} selectDay 日期，格式为YYYY-MM-DD
     */
    getSignInMsg(selectDay) {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      // this.positionInfo.longitude = 114.0719061;
      // this.positionInfo.latitude = 22.7255428;
      const params = {
        loginType: this.loginType,
        activityCode: this.activityCode,
        channelCode: this.channelCode,
        unionId: this.unionId || '',
        alipayUserId: sessionStorage.getItem('alipayUserId') || '',
        selectDay: selectDay,
        longitude: this.positionInfo.longitude,
        dimension: this.positionInfo.latitude,
        coordinateType: this.positionInfo.coordinateType || CoordinateType.GCJ02,
      };
      if (userInfo) {
        params.memberNo = userInfo.memberCenterId;
      }
      this.$api.post({
        sc: 'mobileMarketing',
        url: `/h5/checkin/getCheckInfo`,
        params: params,
        success: (r) => {
          Toast.clear();
          if (r && r.result) {
            // 处理时间，用于日历组件
            if (r.result.checkinWeekRecordsList) {
              this.dateInfoList = r.result.checkinWeekRecordsList;
            } else {
              this.dateInfoList = [];
            }
            this.userInfoList = r.result.extraAward.userInfoList || [];
            this.giftList = r.result.extraAward || [];
            this.formCustom = r.result;
            this.formCustom.checkinGuideInfo = r.result.checkinGuideInfo ? r.result.checkinGuideInfo.replace(/ihlp/g, 'hd') : '';
            // 设置签到日历背景图
            if (this.formCustom.signBackgroundUrl) {
              const dom = document.getElementById('top-half');
              const style = `background-image:url(${this.getPicUrl(this.formCustom.signBackgroundUrl)})`;
              dom.setAttribute('style', style);
            }
            this.activityStatus = r.result.status || '';
            this.activityStartTime = r.result.activityStartTime || '';
            this.activityEndTime = r.result.activityEndTime || '';
            this.checkinType = r.result.checkinType;
            if (this.activityObj.checkinCategory === CHECK_IN_CATEGORY.OFFLINE_CHECK_IN && this.activityStatus !== SignInStatus.running) {
              this.$refs.activityStatusDialogRef.open();
            }
            if (r.result.status === SignInStatus.finished) {
              this.activityEnd = true;
              this.giftList = [];
              this.noGift = '活动已结束';
            }
            if (r.result.status === SignInStatus.paused) {
              this.activityPaused = true;
              this.giftList = [];
              this.noGift = '活动已暂停';
            }
            // 未开始状态重置下，防止未开始停留在当前页面，等时间到了直接点击按钮后按钮文案未更新状态
            this.activityNotStarted = false;
            if (r.result.status === SignInStatus.notStarted) {
              this.activityNotStarted = true;
              this.giftList = [];
              this.noGift = '活动未开始';
            }
            if (this.activityObj.checkinCategory === CHECK_IN_CATEGORY.OFFLINE_CHECK_IN && this.giftList.length === 0) {
              this.noGift = '当前城市暂无活动门店';
            }
          }
        },
        failure: (err) => {
          Toast.clear();
          self.clickFlag = false;
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
    },
    /**
     * 签到
     */
    async signIn() {
      // 正在签到
      if (this.clickFlag) {
        return false;
      }
      // 已签到
      if (this.hadSingIn) {
        return;
      }
      // 登录方式为微信，且没有登录
      if (!this.isLoginFlag && (this.loginType === 'wechat' || this.loginType === 'Alipay')) {
        noLoginHandler(this.loginType, this.activityUrl);
        return;
      }

      // 支付宝登录场景，不是会员，跳转到小程序首页进行入会
      if (this.loginType === LoginType.Alipay && sessionStorage.getItem('isMember') === 'false') {
        goHiHonorIndex(this.loginType, this.activityUrl);
        return;
      }
      Toast.loading({
        message: '签到中...',
        forbidClick: true,
        duration: 0,
      });
      const self = this;
      this.clickFlag = true;
      const userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
      const userBase = Object.assign({}, userInfo);
      const nickName = userBase.nickName || '';
      this.$api.post({
        sc: 'mobileMarketing',
        url: `h5/checkin/doCheckin`,
        params: {
          loginType: this.loginType,
          activityCode: self.activityCode,
          channelCode: self.channelCode,
          unionId: self.unionId || '',
          alipayUserId: sessionStorage.getItem('alipayUserId') || '',
          checkinLocation: 0,
          userNickName: nickName,
          userRewardRegion: this.adminRegions,
        },
        success: (r) => {
          Toast.clear();
          if (r.code == 500) {
            this.automaticCheckIn = true;
            Dialog({ message: r.message });
            this.clickFlag = false;
          } else {
            this.automaticCheckIn = true;
            // 只获得每日签到奖励提示语
            this.signInTip = r.result.tips || '';
            this.successGiftList = [];
            r.result.bigwheelRewardRecordDetailsDtoList.forEach((el) => {
              this.successGiftList.push(el);
            });
            let rewardTitle = '';
            this.successGiftList.forEach((item) => {
              rewardTitle = self.convertWord(item.rewardSettingType);
              item.rewardTypeContent = rewardTitle;
            });
            self.getSignInMsg(this.today);
            if (this.taskId) {
              this.updateTaskStatus();
            }
            this.clickFlag = false;
            if (this.successGiftList.length === 0) {
              this.isSuccessShow1 = true;
            } else if (this.successGiftList.length === 1 && !this.successGiftList[0].id) {
              // 只获得了每日签到奖励，对应无id值，展示每日签到奖励弹框
              this.isSuccessShow2 = true;
            } else {
              this.isSuccessShow = true;
            }
            // 开启消息订阅通知，且登录类型为微信
            if (this.activityObj.enableMessageNotifications === EnableMessageNotifications.open && this.loginType === LoginType.Wechat) {
              let countDown = 1; //倒计时1秒后，自动跳转小程序，拉起消息订阅授权弹窗
              const timerId = setInterval(() => {
                if (countDown === 0) {
                  clearInterval(timerId);
                  if (this.isSuccessShow || this.isSuccessShow1 || this.isSuccessShow2) {
                    let params = [];
                    params = this.successGiftList.map((item) => ({
                      rewardType: item.rewardType, //0未中奖 1虚拟 2实物 3优惠券 4积分 5代金券 6赠品券
                      collectionType: item.collectionType, //领取类型(1:邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发串码(虚拟));4:免单抽奖
                      businessId: item.bigwheelRewardRecodeId, //普通大转盘传recordId、定时盲盒和定时新盲盒传activityCode、专题传activityCode、签到传bigwheelRewardRecodeId
                      businessType: '12', //业务类型 12.签到  7.专题活动 9.大转盘
                      goodsId: item.goodsId,
                    }));
                    queryNeedNotifyAwardInfo(params, this);
                  }
                } else {
                  countDown--;
                }
              }, 500);
            }
          }
        },
        failure: (err) => {
          this.automaticCheckIn = true;
          Toast.clear();
          self.clickFlag = false;
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
    },
    // 通过接口返回的奖励不同类型对应不同文案
    // 签到奖励类型：0连续签到奖励、1累计签到领奖励、2指定日期签到奖励'、3线下门店签到奖励、4每日签到
    convertWord(id) {
      let word = '';
      switch (id) {
        case '0':
          word = '连续签到';
          break;
        case '1':
          word = '累计签到';
          break;
        case '2':
          word = '指定日期签到';
          break;
        case '3':
          word = '线下门店签到';
          break;
        case '4':
          word = '签到奖励';
          break;
        default:
          word = '';
          break;
      }
      return word;
    },
    //任务中心 签到任务完成
    updateTaskStatus() {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.$api.post({
        sc: 'member2',
        url: `memberInfoMiniManage/updTaskDone`,
        params: {
          id: this.taskId,
          uniqId: this.loginType == 'wechat' ? this.userBase.unionid || '' : this.userBase.userId || '',
          idType: this.loginType == 'wechat' ? '1' : '6',
        },
        success: (r) => {
          Toast.clear();
          if (r.code == 500) {
            //	Dialog({ message: "系统繁忙，请稍后重试。" });
          }
          if (r.code == 200) {
            Dialog({ message: '任务完成！' });
          }
        },
        failure: (err) => {
          Toast.clear();
          Dialog({ message: '活动过于火爆，请稍后再试' });
        },
      });
    },
    // 判断是否在小程序内
    handleMiniprogramJudge() {
      let that = this;
      if (this.loginType == LoginType.Wechat) {
        //判断是否在微信小程序环境
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            that.miniprogramFlag = res.miniprogram;
          }
        });
      } else if (this.loginType == LoginType.Alipay) {
        loadAlipayWebViewScript().then((res) => {
          if (res) {
            //判断是否运行在支付宝小程序环境里
            my.getEnv(function (res) {
              if (res.miniprogram) {
                that.miniprogramFlag = res.miniprogram;
              }
            });
          }
        });
      }
    },
    // 查询会员信息
    queryMemberInfo() {
      let params = {
        uniqId: this.loginType == 'wechat' ? this.userBase.unionid || '' : this.userBase.userId || '',
        idType: this.loginType == 'wechat' ? '1' : '6',
      };
      this.$api.post({
        noLoading: true,
        sc: 'member2',
        url: 'memberInfoMiniManage/queryMemberInfoByUnionIdAndIdType',
        params,
        success: (res) => {
          this.memberInfo = res.result;
        },
      });
    },
    //检测是否已经预约成功了
    checkShoppingGuide(id) {
      return new Promise((resolve, reject) => {
        this.$api.get({
          noLoading: true,
          sc: 'mobileMarketing',
          url: `guide/getGuideByActivationCodeId/${id}`,
          params: null,
          success: (r) => {
            resolve(r);
          },
        });
      });
    },
    //埋码-会员中心任务
    handleIntoSignIn() {
      const params = {
        actionCode: '800000006',
        actionName: '签到',
        content: {
          channel: this.loginType == 'undefined' ? '' : this.loginType == 'wechat' ? '微信' : '支付宝',
          load: 1, //针对加载事件增加{“load”: “1”}
          eventType: 1,
          taskId: this.taskId,
          activityCode: this.activityCode,
          url: location.origin + '/hd/hdmain?activityCode=' + this.activityCode + '&taskId=' + this.taskId,
        },
      };
      const eventTrackingData = JSON.parse(sessionStorage.getItem('eventTrackingData') || '{}');
      if (eventTrackingData && eventTrackingData.storeCode && eventTrackingData.guideUserId) {
        params.content.activityName = eventTrackingData.activityName;
        params.content.activityType = eventTrackingData.activityType;
        params.content.guideUserId = eventTrackingData.guideUserId;
        params.content.channelCode = eventTrackingData.storeCode;
      }
      comUtils.handleBatchReport(this, params);
    },
    // 跳转预约导购
    async toAppointmentGuide() {
      const { result } = await this.checkShoppingGuide(this.awardObj.exchangeActivationCodeId);
      this.path =
        result && result.guideId
          ? `subpackages/activity/pages/shoppersService/serviceDetail/service-detail?id=${result.guideId}&activityUrl=${this.activityUrl}`
          : `subpackages/activity/pages/shoppersService/createService/create-service?activationCodeId=${this.awardObj.exchangeActivationCodeId}&collectionType=${this.awardObj.collectionType}&drawType=${this.drawType}&activityUrl=${this.activityUrl}`;
      let url = `/${this.path}`;
      const userBase = sessionStorage.getItem('userInfo');
      if (!userBase) {
        url += '&refresh=1';
      } else if (!userBase.member) {
        url += '&refresh=1';
      }
      sessionStorage.setItem('needRefreshPage', true);
      if (this.loginType === LoginType.Wechat) {
        wx.miniProgram.navigateTo({
          url: url,
          success: function () {
            console.log('跳转回小程序的页面success');
          },
          fail: function (res) {
            console.log('跳转回小程序的页面fail', res);
          },
        });
      } else {
        my.navigateTo({
          url: url,
        });
      }
    },
    closeEnd() {
      this.codeShow = false;
    },
    // 线下门店签到成功回调
    checkInSuccessHandler(result) {
      this.successGiftList = [];
      if (result.length >= 0) {
        result.forEach((el) => {
          //积分不展示在结果弹窗的列表里
          this.successGiftList.push(el);
        });
        // 更新状态
        this.getSignInMsg(this.today);
        if (this.successGiftList.length === 0) {
          this.isSuccessShow1 = true;
        } else if (this.successGiftList.length === 1 && !this.successGiftList[0].id) {
          this.isSuccessShow2 = true;
        } else if (this.successGiftList.length === 1 && this.successGiftList[0].rewardType === GoodsType.noAward) {
          this.isSuccessShow1 = true;
          if (this.successGiftList[0].jumpUrl) {
            this.showToJoin = true;
          } else {
            this.showToJoin = false;
          }
        } else {
          this.isSuccessShow = true;
        }
      }
    },
    closeSignSuccessModal() {
      this.isSuccessShow1 = false;
      this.showToJoin = false;
    },
    // 线下门店签到奖励无，配置自定义跳转链接
    toJoin() {
      this.awardObj = this.successGiftList[0];
      this.toNextStep();
      this.isSuccessShow1 = false;
    },
    refreshTaskList() {
      // 更新状态
      this.getSignInMsg(this.today);
    },
  },
};
</script>

<style lang="scss" scoped>
.top-half {
  background-size: 100% 325px;
  background-repeat: no-repeat;
  width: 100%;
  padding-bottom: calc(824 / 749 * 100%);
  position: relative;
}
.top-half-offline {
  width: 100vw; /* 占满屏幕宽度 */
  aspect-ratio: 1080 / 688; /* 直接写入原图宽高，化简后等同于 135 / 86 */

  background-repeat: no-repeat;
  background-size: 100% 100%; /* 此时容器比例与原图完全一致，100% 即可完美铺满 */
  background-position: center;
}
.sign_in {
  width: 100%;
  min-height: 100vh;
  background: #f8f8f8;
  position: relative;
  overflow: hidden;
}
.background-img {
  img {
    width: 100%;
  }
}
.sign_in .disabled {
  background: #f7f7f7 !important;
  color: #bbbec4 !important;
  box-shadow: 0 0 10px 4px rgba(187, 219, 235, 0.19) !important;
}
.week-calendar {
  box-sizing: border-box;
  background: #ffffff;
  box-shadow: 0 0 12px 8px rgba(162, 162, 162, 0.07);
  border-radius: 10px;
  width: 92%;
  left: 4%;
  position: absolute;
  top: 150px;
  .sign-in-day {
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    font-weight: 600;
    padding: 10px;
  }
  .bg-gray-important {
    filter: grayscale(100%);
  }
  .week-calendar-list {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    justify-content: space-around;
    scrollbar-width: 0px;
    margin-top: 12px;
    width: 100%;
    .week-calendar-list-item {
      margin: 4px 0;
      width: calc(100% / 7);
      .text-gray-important {
        color: #c3c3c3;
      }
      .week-calendar-day {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        // '签'样式
        .sign-font {
          width: 30px;
          height: 30px;
          line-height: 30px;
          border-radius: 50%;
          background: #f4f4f4;
          border: 1px solid rgba(221, 221, 221, 1);
          font-size: 12px;
          color: rgba(0, 0, 0, 0.25);
          letter-spacing: 0;
          font-weight: 400;
        }
        // '+积分'样式
        .points-font {
          width: 30px;
          height: 30px;
          line-height: 30px;
          border-radius: 50%;
          background: #e1f0ff;
          border: 1px solid rgba(37, 111, 255, 1);
          font-size: 12px;
          color: #256fff;
          letter-spacing: 0;
          font-weight: 400;
        }
        img {
          width: 30px;
          height: 30px;
        }
      }
      .date {
        margin-top: 5px;
        font-size: 12px;
        letter-spacing: 0;
        text-align: center;
        font-weight: 400;
      }
    }
    .today {
      color: #256fff;
    }
    .not-today {
      color: #c3c3c3;
    }
  }
  // 头部星期
  .week-days {
    display: flex;
    text-align: center;
    margin-top: 25px;
    justify-content: space-around;
    background: #fbfbfb;
    width: 100%;
    div {
      font-size: 12px;
      color: #c3c3c3;
      letter-spacing: 0;
      font-weight: 400;
    }
  }
  // 展开收起
  .expend-more {
    text-align: center;
    margin-top: 16px;
    margin-bottom: 15px;
    span {
      font-size: 12px;
      color: #999999;
      font-weight: 400;
    }
    >>> .van-icon {
      top: 2px !important;
    }
  }
  .week-calendar-list::-webkit-scrollbar {
    width: 0 !important;
  }
  .sign-in-button {
    width: 90%;
    height: 40px;
    border-radius: 46px;
    text-align: center;
    line-height: 40px;
    margin-left: 5%;
    font-size: 16px;
    color: #ffffff;
    letter-spacing: 0;
    font-weight: 600;
  }
}
.float-points {
  position: absolute;
  left: 7.4%;
  z-index: 10;
  .rule-and-query1 {
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    & span:nth-child(1) {
      font-size: 12px;
      font-weight: 400;
    }
    & span:nth-child(2) {
      font-size: 29px;
      font-weight: 600;
      margin: 0 4.5px 0 4px;
    }
    & span:nth-child(3) {
      font-size: 17px;
    }
  }
}

.float-item {
  position: absolute;
  right: 0;
  z-index: 10;
  width: 16.7%;
  height: 26.5px;
  .rule-and-query {
    border: 1px solid rgba(255, 255, 255, 1);
    border-right: transparent;
    border-radius: 50px 0 0 50px;
    font-size: 12px;
    color: #ffffff;
    letter-spacing: 0;
    text-align: center;
    font-weight: 400;
    padding: 4px 5px;
  }
}
.rule-float-top {
  top: 5px;
}
.query-float-top {
  top: 50px;
}
.query-float-top-offline {
  top: 47.47vw;
}

.van-dialog {
  overflow: inherit;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  .explain {
    width: 345px;
    height: 332.5px;
    padding: 12px 25.5px 19.5px 25px;
    background: #ffffff;
    border-radius: 12px;
    position: relative;
    .explain_title {
      padding: 15px 0;
      font-size: 18px;
      color: #000000;
      font-weight: bold;
      text-align: center;
    }
    .explain_content {
      height: 240.5px;
      overflow: auto;
      font-size: 14px;
      color: #000000;
    }
    .explain_content /deep/ img {
      width: 100%;
    }
    .explain_closeDialog {
      width: 30px;
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: white;
      font-size: 23px;
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translate(-50%, 150%);
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
.success-dialog {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  position: fixed;
  top: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: column;
  .success {
    width: 82.7%;
    margin-bottom: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 12.5px;
    background-image: linear-gradient(180deg, #ffffff 0%, #f8fbff 25% #f1f6ff 50%, #eaf1ff 75%, #e2ecff 100%);
    .success_title {
      font-size: 18px;
      color: #000000;
      text-align: center;
      font-weight: 600;
      margin: 28px 0 10px;
    }
    .success_content {
      width: 100%;
      padding: 0 11px;
      max-height: 202px;
      overflow: scroll;
      .success-gift-list {
        background: #ffffff;
        border-radius: 6px;
        width: 92%;
        height: 60px;
        margin: 0 auto;
        margin-bottom: 7.5px;
        .reward-content {
          display: flex;
          align-items: center;
          img {
            height: 42px;
            width: 42px;
            margin: 9px 8px 9px 7.5px;
          }
          .gift-info {
            width: 100%;
            .gift-item {
              display: flex;
              align-items: flex-end;
              width: 100%;
              justify-content: space-between;
              .gift-title {
                font-size: 14px;
                color: #999999;
                letter-spacing: 0;
                font-weight: 400;
              }
              .gift-name {
                font-size: 14px;
                color: #000000;
                letter-spacing: 0;
                font-weight: 500;
                text-overflow: ellipsis;
                -webkit-line-clamp: 1; //最多显示1行
                overflow: hidden;
                white-space: nowrap;
                max-width: 130px;
              }
              .button-item {
                width: 60px;
                height: 27px;
                line-height: 27px;
                border: 1px solid rgba(37, 111, 255, 1);
                border-radius: 15px;
                margin-right: 12.5px;
                white-space: nowrap;
                overflow: hidden;
                flex-shrink: 0;
              }
              .btn {
                font-size: 12px;
                color: #256fff;
                letter-spacing: 0;
                text-align: center;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
    .reward_query {
      width: 77.3%;
      height: 43px;
      background: #256fff;
      border-radius: 24px;
      margin: 10px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        font-size: 16px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 18.05px;
        font-weight: 400;
      }
    }
  }
  .closeDialog {
    width: 30px;
    height: 30px;
    border: 1px solid white;
    border-radius: 50%;
    color: white;
    font-size: 22.5px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.success_dialog_none {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  position: fixed;
  top: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  .success {
    width: 82.7%;
    height: 201.5px;

    display: flex;
    justify-content: center;
    position: relative;
    border-radius: 12.5px;
    background-image: linear-gradient(180deg, #ffffff 0%, #f8fbff 25% #f1f6ff 50%, #eaf1ff 75%, #e2ecff 100%);
    img {
      width: 100px;
      height: 100px;
      position: absolute;
      top: 35px;
    }
    .success_content {
      width: 100%;
      position: absolute;
      padding-left: 11px;
      padding-right: 11px;
      .success_title {
        margin-top: 133.5px;
        font-size: 18px;
        color: #000000;
        text-align: center;
        font-weight: 600;
      }
      .to-join-btn {
        height: 44px;
        width: 225px;
        border-radius: 22px;
        background-color: #2e71fa;
        color: #ffffff;
        line-height: 44px;
        text-align: center;
        margin: 0 auto;
        font-size: 15px;
        margin-top: 48px;
      }
    }
    .close_dialog {
      width: 30px;
      height: 30px;
      border: 1px solid white;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: white;
      font-size: 22.5px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 200%);
      bottom: 15px;
    }
  }
  .success_height {
    height: 310px;
  }
}

.success_dialog_point {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  position: fixed;
  top: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  .success {
    width: 82.7%;
    height: 310px;
    display: flex;
    justify-content: center;
    position: relative;
    border-radius: 12.5px;
    background-image: linear-gradient(180deg, #ffffff 0%, #f8fbff 25% #f1f6ff 50%, #eaf1ff 75%, #e2ecff 100%);
    img {
      width: 90px;
      height: 90px;
      position: absolute;
      top: 69.5px;
    }
    .success_content {
      width: 100%;
      position: absolute;
      top: 28px;
      padding-left: 11px;
      padding-right: 11px;
      text-align: center;
      .success_point_title {
        font-size: 18px;
        color: #000000;
        font-weight: 600;
      }
      .success_point {
        margin-top: 115px;
        font-size: 16px;
        color: #000000;
        font-weight: 500;
      }
      .success_tip {
        margin-top: 2px;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        font-weight: 400;
      }
      .to_use {
        margin: 30px auto 0;
        width: 60%;
        height: 43px;
        background: #256fff;
        border-radius: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        .btn {
          font-size: 16px;
          color: #ffffff;
          letter-spacing: 0;
          text-align: center;
          line-height: 18.05px;
          font-weight: 400;
        }
      }
    }
    .close_dialog {
      width: 30px;
      height: 30px;
      border: 1px solid white;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: white;
      font-size: 22.5px;
      position: absolute;
      left: 50%;
      transform: translate(-50%, 200%);
      bottom: 15px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/sign-in.vue